module.exports = __webpack_public_path__ + "images/bannerEN-a750fef8886dc18cce51b00b17e1e2cc.jpg";